export default function SeoTrustStrip() {
  return (
    <section className="seo-trust-strip" aria-label="Señales de confianza">
      <div className="seo-trust-strip__item">
        <strong>Concesionarios verificados</strong>
        <span>Revisamos datos básicos del negocio y contacto</span>
      </div>
      <div className="seo-trust-strip__item">
        <strong>Precio comparable</strong>
        <span>Señales cuando hay vehículos similares en la zona</span>
      </div>
      <div className="seo-trust-strip__item">
        <strong>Contacto por WhatsApp</strong>
        <span>Desde cada publicación con contexto del vehículo</span>
      </div>
      <div className="seo-trust-strip__item">
        <strong>Checklist de compra</strong>
        <span>Guía práctica antes de pagar o firmar</span>
      </div>
    </section>
  );
}
